export const redirect = (url) => {
  document.location.href = url;
}
